module.exports = __webpack_public_path__ + "static/media/bg-accordion-pcp.05e39957.jpg";